import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import Mixpanel from 'utils/mixpanelService';

function VisibleOnScrollTracking({ children, section }) {
  const visibilityChange = isVisible => {
    if (isVisible) {
      const { pathname } = window.location;
      const page = pathname.includes('/landing/')
        ? 'Landing Page'
        : 'Home Page';
      const event = `${page} - ScrollTo`;
      setTimeout(
        () =>
          Mixpanel.track(event, {
            path: window.location.pathname,
            section,
          }),
        10000,
      );
    }
  };
  return (
    <VisibilitySensor
      onChange={visibilityChange}
      scrollCheck
      scrollDelay={500}
      delayedCall
    >
      {children}
    </VisibilitySensor>
  );
}

VisibleOnScrollTracking.propTypes = {
  children: PropTypes.node,
  section: PropTypes.string,
};

export default VisibleOnScrollTracking;
